import { render, staticRenderFns } from "./dashboardSurvey.vue?vue&type=template&id=40666617&"
import script from "./dashboardSurvey.vue?vue&type=script&lang=js&"
export * from "./dashboardSurvey.vue?vue&type=script&lang=js&"
import style0 from "./dashboardSurvey.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports